import { render, staticRenderFns } from "./IconRamadanLanterns.vue?vue&type=template&id=39d20142&"
import script from "./IconRamadanLanterns.vue?vue&type=script&lang=js&"
export * from "./IconRamadanLanterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports